import { Design, Intent } from 'enums';
import * as React from 'react';

import { IProps as IButtonProps } from './Button';
import { DefaultButtonLink } from './styles';

type ToFunc = () => { pathname: string; search: string };
interface IProps extends IButtonProps {
  children: React.ReactChild | React.ReactNode;
  to: string | ToFunc;
  intent?: Intent;
  design?: Design;
  onClick?: React.MouseEventHandler<HTMLAnchorElement> &
    React.MouseEventHandler<HTMLButtonElement>;
}

const ButtonLink = ({ intent, design, ...props }: IProps) => {
  return <DefaultButtonLink {...props} $intent={intent} $design={design} />;
};

export default ButtonLink;
